/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="user.service.ts" />
/// <reference path="../file/file.service.ts" />

module Eseebase {
    export class PasswordResetController implements angular.IController{
        private token: string;
        private tokenStatus: string;
        private newPassword: string;
        private passwordRepeat: string;
        private passwordIsChanged: boolean;
        $onInit = () => { };
         
        constructor(private $scope: ng.IScope,
            private userService: UserService,
            private $mdDialog: any,
            private $routeParams: any,
            private $rootScope: any
        ) {
            var vm = this;
            this.token = $routeParams.token.substring(1);
            this.userService.validateToken(this.token).then(() => {
                vm.tokenStatus = 'valid';
                vm.$rootScope.$broadcast('$hideLoader');
            }, () => {
                vm.tokenStatus = 'invalid';
                vm.$rootScope.$broadcast('$hideLoader');
            });
        }

        public changePassword() {
            var vm = this;
            this.userService.resetPassword(this.token, this.newPassword).then(() => {
                vm.passwordIsChanged = true;
            }, () => {
                vm.showAlert('eseeBASE', 'The token is incorrect or expired');
            });
        }

        private showAlert(title: string, message: string) {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(message)
                    .ok('OK')
            );
        }
    }

    PasswordResetController.$inject = ['$scope', 'UserService', '$mdDialog', '$routeParams', '$rootScope'];

    angular
        .module('eseebase')
        .controller('PasswordResetController', PasswordResetController);
}

